import { NrlkClient } from "../model/client.js";
import { NrlkException } from "../model/exception.js";

/**
 * Lecture des données d'un client par son ID
 * 
 * @param {int} idClient ID du client
 * 
 * @throws {NrlkException}
 * 
 * @returns {Promise} Client
 */
export async function getClient(idClient) {
    try {
        // Vérification que le champs ID est bien renseigné et un integer
        if (!idClient || isNaN(idClient)) {
            throw new NrlkException("L'ID du client est obligatoire.");
        }

        // Initialisation du model Client
        const client = new NrlkClient(window.entreprise, window.token);

        const data = await client.getClient(idClient);
        return data.data;
    } catch (error) {
        throw new NrlkException(error);
    }
}